import { fetchApi } from '@/config/axiosSetting';
import {
  GetFabImagesQueryFunctionParamsType,
  GetFabImagesQueryResponseType,
} from '@/modules/adjusterReportModules/adjusterReport/queries/imageFab/getFabImages/getFabImagesQuery.type';

export const getFabImagesFunction = (
  params: GetFabImagesQueryFunctionParamsType,
): Promise<GetFabImagesQueryResponseType> => {
  return fetchApi.get(params.url, { params: { damaged_id: params.damagedId } });
};
